import { useEffect, useRef } from 'react';

import { Color, colors } from 'theme';
import { getStaticImageSrc } from 'utils/getImageSrc';
import { useLoadSvgContent } from 'utils/hooks';

import { IconContainer } from './Icon.styled';
import { IconName } from './IconName';
import { cssFilterForColor } from './cssFilterForColor';

type Props = {
  name: IconName;
  size: number;
  initialColorName: Color | 'todo-replace-me';
  keepColorOnLoad?: boolean;
  opacity?: number;
  'data-qa-id'?: string;
};

export function Icon({
  name,
  size,
  initialColorName: propInitialColorName,
  keepColorOnLoad,
  opacity,
  'data-qa-id': dataQaId,
}: Props) {
  const { svgSrc, svgContent, loadSvgContent } = useLoadSvgContent(
    getStaticImageSrc(`icons/normalized/${name}.svg`)
  );

  const initialColorName =
    // `todo-replace-me` was added to facilitate the transition
    // Remove it once we replace all occurrences
    propInitialColorName === 'todo-replace-me'
      ? 'aluminum'
      : propInitialColorName;

  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    const img = imgRef.current;
    if (!img) return;

    if (img.complete) loadSvgContent();
    else img.addEventListener('load', loadSvgContent);
  }, [loadSvgContent]);

  const color = keepColorOnLoad ? colors[initialColorName] : undefined;

  if (!svgContent) {
    return (
      <IconContainer
        $size={size}
        $color={color}
        $opacity={opacity}
        data-qa-id={dataQaId}
      >
        <img
          ref={imgRef}
          src={svgSrc}
          width={size}
          height={size}
          alt={`${name} icon`}
          style={{ filter: cssFilterForColor(initialColorName) }}
        />
      </IconContainer>
    );
  }

  return (
    <IconContainer
      $size={size}
      $color={color}
      $opacity={opacity}
      data-qa-id={dataQaId}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
}
